export default __webpack_public_path__ + "static/media/work-learn.food-entrepreneurship.d80f7541.jpg";